import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { withSameProp } from "../../common/utils";
import { Grid } from "@mui/material";
import { propSimpleEnumField } from "../../common/entityStoreForm";
import { propRequired } from "../../common/entityStoreValidators";
import { useSimpleDialog } from "../../common/dialog";
import { EnumItemDto } from "../../common/enum";

export const CustomerReactivationRunPage = withSameProp("fake", () => (props: { fake?: boolean }) => {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: {},
        id: null,
        propValidators: [
            propRequired("type"),
        ]
    }));
    const simpleDialog = useSimpleDialog();
    function renderParams() {
        return <>
            <Grid item xs={12}>{propSimpleEnumField(useParamsStore)("type", "Type", types)}</Grid>
        </>;
    }
    return <>
        {simpleDialog.render()}
        <Run name="Customer reactivation" fake={props.fake} hub="customerReactivationRun"
            useParamsStore={useParamsStore} renderParams={renderParams} />
    </>;
});

interface RunParams {
    type?: CustomerReactivationType;
}

enum CustomerReactivationType {
    Basic = 1,
    Rest = 2,
    Lhb = 3,
    Stop = 4,
    Slh = 5,
}

const types: EnumItemDto[] = [
    { id: CustomerReactivationType.Basic, name: "Basic" },
    { id: CustomerReactivationType.Rest, name: "REST" },
    { id: CustomerReactivationType.Lhb, name: "LHB" },
    { id: CustomerReactivationType.Stop, name: "Stop" },
    { id: CustomerReactivationType.Slh, name: "SLH" },
]
